/**
 * Crypto-secure request id, with a legacy-browser fallback.
 *
 * Replaces `Math.random().toString(16).slice(2)` style generators —
 * those collide more often than people expect under load (~1 in a few
 * thousand for 16-hex-char IDs), and the bank's outbound APIs use these
 * as deduplication keys.
 *
 * Output is a UUID v4 in modern browsers (e.g. `f0a3...-...`). In legacy
 * environments without `crypto.randomUUID`, falls back to
 * `<timestamp>-<random>` which is still collision-resistant in practice
 * within a single client session.
 */
export function generateRequestId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2)}`;
}
